/**
 * @generated SignedSource<<36f8dca709a84bf91d53bb8c60d6ed6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PreQuoteDescription_shipmentQuote$data = {
  readonly serviceMethod: {
    readonly isFreight: boolean | null;
    readonly serviceMethodType: string | null;
    readonly serviceType: string | null;
  } | null;
  readonly " $fragmentType": "PreQuoteDescription_shipmentQuote";
};
export type PreQuoteDescription_shipmentQuote$key = {
  readonly " $data"?: PreQuoteDescription_shipmentQuote$data;
  readonly " $fragmentSpreads": FragmentRefs<"PreQuoteDescription_shipmentQuote">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PreQuoteDescription_shipmentQuote",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFreight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceMethodType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "e9551a17f24cd65c4f0e5fc431d63ab0";

export default node;
